/* np-signup.js: the site's own sign-up pop-up (snippets/np-signup.liquid, 22 Oct 2026; replaces Klaviyo form WT3QPR).

   A/B test: A shows the email step straight away; B asks "What do you train for?" first. Theme settings pick A, B or
   a 50:50 split (data-mode); in a split each visitor is given a version once and keeps it (localStorage npsu-v).

   When it opens (the Klaviyo popup's rules, kept): 15 seconds on a page, or 30% down it, or (desktop) the pointer
   leaving the top of the window, whichever comes first. Never on the home page (Klaviyo excluded it too), the cart or
   account pages, for a signed-in customer, for a visitor Klaviyo already knows, after a sign-up, within 7 days of being
   closed, or twice in one visit. Added: it waits until the cookie banner has been answered (Pandectes sets the
   _pandectes_gdpr cookie) and until no other panel (cart, menu, search) is open, so overlays never stack.

   Sign-up: one POST to Klaviyo's public client subscriptions endpoint with the site's public key (data-company) and
   the "Email List" (data-list), source "Efectiv site pop-up A" or "... B (sports)", and profile properties
   "Sign-up pop-up" (A or B) and, for B, "Training for" (the sport). 202 = done (checked live 22 Oct 2026: the
   profile gets the source, both properties and the list). The list starts the "EN | Welcome" flow, whose first email
   goes straight away with the subscriber's own 10% EFECT code, so the last screen says it is on its way to the
   address they typed (Adam 3 Nov 2026: "Unique code."; until then it showed WELCOME10 and applied it).

   Analytics (npTrack, np-chrome.js): signup_popup_shown_a / _b, signup_popup_sport (B, with the sport) and
   signup_popup_submitted_a / _b, so Google Analytics can compare the versions without extra set-up.

   ?signup=preview opens it once the cookie banner is answered, switch on or off (&v=a or &v=b picks the version), and
   leaves no "closed", "done" or version memory. */
(function () {
  "use strict";
  var root = document.getElementById("npsu");
  if (!root) return;
  var preview = /[?&]signup=preview(&|$)/.test(location.search);
  if (root.getAttribute("data-on") !== "true" && !preview) return;

  var KEY = "npsu", DAYS = 7, DELAY = 15000, SCROLL = 0.3;
  var API = "https://a.klaviyo.com/client/", REV = "2024-10-15";
  var card = root.querySelector(".npsu-card");
  var form = root.querySelector(".npsu-form");
  var input = root.querySelector(".npsu-input");
  var btn = form.querySelector(".npsu-btn");
  var err = root.querySelector(".npsu-err");
  var btnLabel = btn.textContent;
  var opened = false, armed = false, done = false, lastFocus = null, sport = "";

  function remember(k, v) { if (preview) return; try { localStorage.setItem(k, v); } catch (e) {} }
  function memory(k) { try { return localStorage.getItem(k) || ""; } catch (e) { return ""; } }

  /* which version: forced in a preview, fixed by the setting, or given once in a split */
  var mode = root.getAttribute("data-mode");
  var forced = preview ? (location.search.match(/[?&]v=([ab])(?:&|$)/) || [])[1] : "";
  var variant = forced || (mode === "a" || mode === "b" ? mode : "");
  if (!variant) {
    variant = memory("npsu-v");
    if (variant !== "a" && variant !== "b") { variant = Math.random() < 0.5 ? "a" : "b"; remember("npsu-v", variant); }
  }

  function track(name, extra) {
    if (!window.npTrack) return;
    var d = { page: location.pathname, variant: variant };
    for (var k in extra || {}) d[k] = extra[k];
    window.npTrack(name, d);
  }

  function klaviyoKnows() {
    var m = document.cookie.match(/(?:^|; )__kla_id=([^;]+)/);
    if (!m) return false;
    try { var o = JSON.parse(atob(decodeURIComponent(m[1]))); return !!(o.$exchange_id || o.$email); } catch (e) { return false; }
  }
  function suppressed() {
    if (preview) return false;
    if (location.pathname === "/" || /^\/(cart|account|checkouts?|challenge|password)(\/|$)/.test(location.pathname)) return true;
    if (root.hasAttribute("data-customer") || klaviyoKnows()) return true;
    var mem = memory(KEY);
    if (mem === "done") return true;
    if (mem.indexOf("closed:") === 0 && Date.now() - Number(mem.slice(7)) < DAYS * 864e5) return true;
    try { if (sessionStorage.getItem(KEY)) return true; } catch (e) {}
    return false;
  }
  if (suppressed()) return;

  /* answered = the consent cookie is set; no banner at all = Pandectes never loaded (page fully loaded, none of its
     globals or element). A banner still loading counts as unanswered, so the pop-up cannot beat it to the screen. */
  function bannerAnswered() {
    if (/(?:^|; )_pandectes_gdpr=/.test(document.cookie)) return true;
    return document.readyState === "complete" && !window.pandectesBannerSettings && !window.PandectesCore && !document.querySelector("pandectes-cmp");
  }
  function otherPanelOpen() {
    if (document.body.style.overflow === "hidden" || document.documentElement.style.overflow === "hidden") return true;
    return [].some.call(document.querySelectorAll('[aria-modal="true"]'), function (d) {
      return d !== card && d.offsetParent !== null && getComputedStyle(d).visibility !== "hidden" && getComputedStyle(d).opacity !== "0";
    });
  }
  /* one of the page's own sign-up forms (home, blog, article; np-signup-inline.js) is on screen or in use: hold off,
     so nobody who has reached a sign-up form gets a second one on top of it (live check, 22 Oct 2026: the 30% scroll
     opened the pop-up just as an article reader reached its form) */
  function inlineBusy() {
    var a = document.activeElement;
    if (a && a.closest && a.closest("[data-np-kl]")) return true;
    return [].some.call(document.querySelectorAll("[data-np-kl]"), function (w) {
      var r = w.getBoundingClientRect(), i = w.querySelector('input[type="email"]');
      return (r.height > 0 && r.bottom > 0 && r.top < innerHeight) || (i && i.value.trim() !== "");
    });
  }
  function loadCss() {
    if (document.getElementById("npsu-css")) return;
    var l = document.createElement("link");
    l.id = "npsu-css"; l.rel = "stylesheet"; l.href = root.getAttribute("data-css");
    document.head.appendChild(l);
  }
  function arm() {
    if (armed || opened) return;
    armed = true;
    loadCss();
    (function wait() {
      if (opened) return;
      if (suppressed()) return;
      /* the preview waits for the cookie banner too: on a phone the banner sits over the sheet otherwise */
      if (!bannerAnswered() || (!preview && (otherPanelOpen() || inlineBusy()))) { setTimeout(wait, 1000); return; }
      /* open only once its styles are in, so it never flashes unstyled; if they fail to load, it stays shut */
      var css = document.getElementById("npsu-css");
      if (css && !css.sheet) { css.addEventListener("load", wait, { once: true }); return; }
      open();
    })();
  }

  function step(name, focusEl) {
    [].forEach.call(root.querySelectorAll("[data-npsu-step]"), function (s) { s.hidden = s.getAttribute("data-npsu-step") !== name; });
    var h = root.querySelector('[data-npsu-step="' + name + '"] .npsu-h');
    card.setAttribute("aria-labelledby", h.id);
    if (focusEl) focusEl.focus({ preventScroll: true });
  }
  function open() {
    if (opened) return;
    opened = true;
    try { sessionStorage.setItem(KEY, "1"); } catch (e) {}
    lastFocus = document.activeElement;
    step(variant === "b" ? "sport" : "form");
    root.hidden = false;
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add("is-open"); }); });
    card.focus({ preventScroll: true });
    document.addEventListener("keydown", onKey);
    track("signup_popup_shown_" + variant);
  }
  function close() {
    root.classList.remove("is-open");
    document.removeEventListener("keydown", onKey);
    if (!done) remember(KEY, "closed:" + Date.now());
    setTimeout(function () { root.hidden = true; }, 300);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function onKey(e) {
    if (e.key === "Escape") { close(); return; }
    if (e.key !== "Tab") return;
    var f = [].filter.call(card.querySelectorAll("button, input, a[href]"), function (el) { return el.offsetParent !== null && !el.disabled; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === card)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  [].forEach.call(root.querySelectorAll("[data-npsu-close]"), function (b) { b.addEventListener("click", close); });

  /* B: the sport, then the email step headed with it */
  [].forEach.call(root.querySelectorAll("[data-sport]"), function (b) {
    b.addEventListener("click", function () {
      if (sport) return;
      sport = b.getAttribute("data-sport");
      b.setAttribute("aria-pressed", "true");
      track("signup_popup_sport", { sport: sport });
      root.querySelector("[data-npsu-kicker]").textContent = sport === "Something else" ? "The Inner Circle" : "Training for " + sport;
      /* hold the yellow for a moment so the tap visibly lands, then the email step */
      setTimeout(function () { step("form", input); }, 180);
    });
  });

  function post(path, body) {
    return fetch(API + path + "?company_id=" + encodeURIComponent(root.getAttribute("data-company")), {
      method: "POST",
      headers: { "content-type": "application/vnd.api+json", accept: "application/vnd.api+json", revision: REV },
      body: JSON.stringify(body)
    });
  }
  /* the last screen: "Check your inbox", with the address the code is going to */
  function showDone(email) {
    root.querySelector("[data-npsu-email]").textContent = email;
    step("done", root.querySelector("#npsu-h2"));
  }

  function showErr(msg) { err.textContent = msg; err.hidden = false; input.setAttribute("aria-invalid", "true"); input.focus(); }
  form.addEventListener("submit", function (e) {
    e.preventDefault();
    var email = input.value.trim();
    err.hidden = true; input.removeAttribute("aria-invalid");
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { showErr("Please enter a valid email."); return; }
    btn.disabled = true; btn.textContent = "Signing you up…";
    /* the client endpoint takes the email and custom properties; consent is implied by the call (a "subscriptions"
       consent object is rejected: 400 "'subscriptions' is not a valid field", found by Adam's own test sign-up) */
    var props = { "Sign-up pop-up": variant.toUpperCase() };
    if (sport) props["Training for"] = sport;
    post("subscriptions", { data: { type: "subscription", attributes: {
      custom_source: variant === "b" ? "Efectiv site pop-up B (sports)" : "Efectiv site pop-up A",
      profile: { data: { type: "profile", attributes: { email: email, properties: props } } }
    }, relationships: { list: { data: { type: "list", id: root.getAttribute("data-list") } } } } }).then(function (r) {
      if (!r.ok) throw new Error("Klaviyo " + r.status);
      done = true;
      remember(KEY, "done");
      track("signup_popup_submitted_" + variant, sport ? { sport: sport } : null);
      /* the Klaviyo popup identified the visitor on sign-up; keep that so browse emails still work */
      if (window.klaviyo && typeof window.klaviyo.identify === "function") { try { window.klaviyo.identify({ email: email }); } catch (x) {} }
      showDone(email);
    }).catch(function () {
      btn.disabled = false; btn.textContent = btnLabel;
      showErr("That didn't go through. Please try again.");
    });
  });

  if (preview) { arm(); return; }
  setTimeout(arm, DELAY);
  function onScroll() {
    var max = document.documentElement.scrollHeight - innerHeight;
    if (max > 0 && scrollY / max >= SCROLL) { window.removeEventListener("scroll", onScroll); arm(); }
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  if (window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
    document.addEventListener("mouseout", function (e) { if (!e.relatedTarget && e.clientY <= 0) arm(); });
  }
})();
